import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { FlexGrid } from '@grapecity/wijmo.grid';

/**
 * 列幅設定登録サービス
 * @export RegistUserColumnWidthSettingsService
 * @class RegistUserColumnWidthSettingsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistUserColumnWidthSettingsService extends PlessJsonResponderSub<any> {
  private calbak: () => void;
  private vo = {
    userId: '',
    gridId: '',
  }
  private grid: FlexGrid;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistUserColumnWidthSettingsService
   */
  private getBody(): PlessRequest {
    // グリッドのカラム名：{width: カラム幅（px）, displayFlg: 表示フラグ（0:false,1:true）}をまとめたオブジェクト（columnInfo）を作成
    let tempColumnInfo: Object = {};
    this.grid.columns.map(_ => {
      let columnName = _.header;
      // カラム名に改行コードが含まれている場合は除外
      // ※getUserColumnWidthSettingsでデータを受け取ったときに、カラム名の改行コードを削除したもので判定を行う。
      if (columnName?.includes("\n")) {
        columnName = columnName.replace("\n", "");
      }
      // columnNameに対応するカラム幅と表示フラグを設定
      // 表示フラグはvisibleがtrueのとき'1'、falseのとき'0'
      tempColumnInfo[columnName] = {width: _.width, displayFlg: _.visible ? '1' : '0'};
    });

    return new PlessRequest({
      regist: [{
        UserColumnWidthSettings: {
          condition: {
            UserId: this.vo.userId,
            GridId: this.vo.gridId,
            ColumnInfo: tempColumnInfo
          }
        }
      }]
    });
  }

  /**
   * API呼び出し
   *
   * @param vo
   * @param grid 対象の表
   * @param f コールバック
   * @memberof RegistUserColumnWidthSettingsService
   */
  execute(
    vo: any,
    grid: FlexGrid,
    f: () => void = null
  ): void {
    this.vo = vo;
    this.grid = grid;
    this.calbak = f;
    this.send('registUserColumnWidthSettings', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistUserColumnWidthSettingsService
   */
  success(data: any) {
    if (this.calbak) this.calbak();
  }
}
